import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50 whitespace-nowrap">
                韩漫网
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫网 —— 您的免费韩漫在线阅读平台。提供高清下拉式漫画全集，画质清晰阅读流畅，打造影院级观看体验。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</Link>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">漫画分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          {/* Hot Categories */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">热血漫画</Link>
              </li>
              <li>
                <Link to="/category/thriller" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">悬疑漫画</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                <span>contact@hanmanwang.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-xs"></i>
                </div>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-800">
        <div className="px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-500">
            &copy; 2026 韩漫网 HanManWang.com. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}